import { useCallback } from 'react';

export const useKeyboardActivation = (callback) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback(e);
    }
  }, [callback]);

  return handleKeyDown;
};

